// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2815":"88647238","5133":"cc7084ae"}[chunkId] + ".chunk.css";
};